import { Component, EventEmitter, Inject, Input, Output, ViewEncapsulation } from '@angular/core';

import { JSR310ConversionService } from '../services/jsr310-conversion.service';
import { LocalTime } from '../types/local-time.type';

// Ce composant est une encapsulation pour le composant NgxMatTimepicker afin de pouvoir retoucher son style
@Component({
	selector: 'time-input',
	templateUrl: 'time-input.html',
	styleUrls: ['time-input.css'],
	// Cet indicateur informe qu'il ne faudra pas encapsuler les styles de basic-timepicker.css afin qu'ils s'appliquent au NgxMatTimepicker
	encapsulation: ViewEncapsulation.None
})
export class TimeInputComponent {
	time: Date | null = null;
	
	constructor( //
		@Inject(JSR310ConversionService) private conversionService: JSR310ConversionService,
	) {
	}

	@Input() id!: string;
	
	@Input() disabled: boolean = false;
	
	@Input() stepMinute: number = 5;
	
	@Input() get localTime(): LocalTime | null {
		return this.conversionService.toNullableLocalTime(this.time);
	}
	set localTime(value: LocalTime | null) {
		this.time = this.conversionService.fromNullableLocalTime(value);
	}
	
	@Input() max: LocalTime | null = null;
		
	@Output() localTimeChange = new EventEmitter<LocalTime>();
	
	onTimeChange(time: Date) {
		let localTime = this.conversionService.toMandatoryLocalTime(time);
		
		if (this.max) {
			let changed = false;
			if (this.max[0] < localTime[0]) {
				localTime[0] = this.max[0];
				changed = true;
			}
			
			if (this.max[0] === localTime[0] && this.max[1] < localTime[1]) {
				localTime[1] = this.max[1];
				changed = true;
			}
			
			if (changed) {
				this.localTime = localTime;
			}
		}
		
		this.localTimeChange.emit(localTime);
	}
}